// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import MessageCopyController from "./message_copy_controller"
application.register("message-copy", MessageCopyController)

import TvRefreshController from "./tv_refresh_controller"
application.register("tv-refresh", TvRefreshController)

import AboutFormController from "./about_form_controller"
application.register("about-form", AboutFormController)

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import AddressAutocompleteController from "./address_autocomplete_controller"
application.register("address-autocomplete", AddressAutocompleteController)

import AdminSidebarController from "./admin_sidebar_controller"
application.register("admin-sidebar", AdminSidebarController)

import AnimatedPhrasesController from "./animated_phrases_controller"
application.register("animated-phrases", AnimatedPhrasesController)

import AnnouncementController from "./announcement_controller"
application.register("announcement", AnnouncementController)

import ApiCredentialsController from "./api_credentials_controller"
application.register("api-credentials", ApiCredentialsController)

import ApiFormController from "./api_form_controller"
application.register("api-form", ApiFormController)

import ApiToggleController from "./api_toggle_controller"
application.register("api-toggle", ApiToggleController)

import AppointmentBoardController from "./appointment_board_controller"
application.register("appointment-board", AppointmentBoardController)

import AppointmentCardController from "./appointment_card_controller"
application.register("appointment-card", AppointmentCardController)

import AppointmentController from "./appointment_controller"
application.register("appointment", AppointmentController)

import AppointmentFormController from "./appointment_form_controller"
application.register("appointment-form", AppointmentFormController)

import AppointmentKanbanController from "./appointment_kanban_controller"
application.register("appointment-kanban", AppointmentKanbanController)

import AssigneePickerController from "./assignee_picker_controller"
application.register("assignee-picker", AssigneePickerController)

import AssigneeSelectorController from "./assignee_selector_controller"
application.register("assignee-selector", AssigneeSelectorController)

import AuthModalController from "./auth_modal_controller"
application.register("auth-modal", AuthModalController)

import AutosizeController from "./autosize_controller"
application.register("autosize", AutosizeController)

import AvatarPreviewController from "./avatar_preview_controller"
application.register("avatar-preview", AvatarPreviewController)

import BasicInfoController from "./basic_info_controller"
application.register("basic-info", BasicInfoController)

import BoardController from "./board_controller"
application.register("board", BoardController)

import BoardNewController from "./board_new_controller"
application.register("board-new", BoardNewController)

import BoardSidebarController from "./board_sidebar_controller"
application.register("board-sidebar", BoardSidebarController)

import BoardViewController from "./board_view_controller"
application.register("board-view", BoardViewController)

import BookingFormController from "./booking_form_controller"
application.register("booking-form", BookingFormController)

import BrandingController from "./branding_controller"
application.register("branding", BrandingController)

import BusinessCardController from "./business_card_controller"
application.register("business-card", BusinessCardController)

import BusinessHoursController from "./business_hours_controller"
application.register("business-hours", BusinessHoursController)

import BusinessTypeSelectionController from "./business_type_selection_controller"
application.register("business-type-selection", BusinessTypeSelectionController)

import CalendarController from "./calendar_controller"
application.register("calendar", CalendarController)

import CardModalController from "./card_modal_controller"
application.register("card-modal", CardModalController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import ChecklistController from "./checklist_controller"
application.register("checklist", ChecklistController)

import ClientDocumentationFormController from "./client_documentation_form_controller"
application.register("client-documentation-form", ClientDocumentationFormController)

import ClockController from "./clock_controller"
application.register("clock", ClockController)

import ColorHandlerController from "./color_handler_controller"
application.register("color-handler", ColorHandlerController)

import CommentFormController from "./comment_form_controller"
application.register("comment-form", CommentFormController)

import CommentsController from "./comments_controller"
application.register("comments", CommentsController)

import ConfettiController from "./confetti_controller"
application.register("confetti", ConfettiController)

import ConfirmDeleteController from "./confirm_delete_controller"
application.register("confirm-delete", ConfirmDeleteController)

import CorsConfigController from "./cors_config_controller"
application.register("cors-config", CorsConfigController)

import DescriptionToggleController from "./description_toggle_controller"
application.register("description-toggle", DescriptionToggleController)

import DesignController from "./design_controller"
application.register("design", DesignController)

import DeveloperDocsController from "./developer_docs_controller"
application.register("developer-docs", DeveloperDocsController)

import DragScrollController from "./drag_scroll_controller"
application.register("drag-scroll", DragScrollController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import DropdownManagerController from "./dropdown_manager_controller"
application.register("dropdown-manager", DropdownManagerController)

import FcmNotificationsController from "./fcm_notifications_controller"
application.register("fcm-notifications", FcmNotificationsController)

import FeaturesController from "./features_controller"
application.register("features", FeaturesController)

import FeedComposerController from "./feed_composer_controller"
application.register("feed-composer", FeedComposerController)

import FileDeleteController from "./file_delete_controller"
application.register("file-delete", FileDeleteController)

import FilterListController from "./filter_list_controller"
application.register("filter-list", FilterListController)

import FilterSearchController from "./filter_search_controller"
application.register("filter-search", FilterSearchController)

import FiltersController from "./filters_controller"
application.register("filters", FiltersController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FocusTimerController from "./focus_timer_controller"
application.register("focus-timer", FocusTimerController)

import FormController from "./form_controller"
application.register("form", FormController)

import FormReviewsController from "./form_reviews_controller"
application.register("form-reviews", FormReviewsController)

import FullscreenController from "./fullscreen_controller"
application.register("fullscreen", FullscreenController)

import GeolocationController from "./geolocation_controller"
application.register("geolocation", GeolocationController)

import GraphqlReferenceController from "./graphql_reference_controller"
application.register("graphql-reference", GraphqlReferenceController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import IndustrySelectionController from "./industry_selection_controller"
application.register("industry-selection", IndustrySelectionController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import KanbanController from "./kanban_controller"
application.register("kanban", KanbanController)

import LabelManagerController from "./label_manager_controller"
application.register("label-manager", LabelManagerController)

import LanguageController from "./language_controller"
application.register("language", LanguageController)

import LessonContentController from "./lesson_content_controller"
application.register("lesson-content", LessonContentController)

import LessonContentViewerController from "./lesson_content_viewer_controller"
application.register("lesson-content-viewer", LessonContentViewerController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import ListCelebrationController from "./list_celebration_controller"
application.register("list-celebration", ListCelebrationController)

import MapController from "./map_controller"
application.register("map", MapController)

import MindMapController from "./mind_map_controller"
application.register("mind-map", MindMapController)

import MobileFiltersController from "./mobile_filters_controller"
application.register("mobile-filters", MobileFiltersController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NotificationController from "./notification_controller"
application.register("notification", NotificationController)

import NotificationStatusController from "./notification_status_controller"
application.register("notification-status", NotificationStatusController)

import NotificationsDropdownController from "./notifications_dropdown_controller"
application.register("notifications-dropdown", NotificationsDropdownController)

import OnboardingController from "./onboarding_controller"
application.register("onboarding", OnboardingController)

import OtpController from "./otp_controller"
application.register("otp", OtpController)

import PlanSelectorController from "./plan_selector_controller"
application.register("plan-selector", PlanSelectorController)

import PriceSliderController from "./price_slider_controller"
application.register("price-slider", PriceSliderController)

import ProductShowcaseController from "./product_showcase_controller"
application.register("product-showcase", ProductShowcaseController)

import PromotionalBusinessCardController from "./promotional_business_card_controller"
application.register("promotional-business-card", PromotionalBusinessCardController)

import ProviderTagsController from "./provider_tags_controller"
application.register("provider-tags", ProviderTagsController)

import QrCodeController from "./qr_code_controller"
application.register("qr-code", QrCodeController)

import QuickAddController from "./quick_add_controller"
application.register("quick-add", QuickAddController)

import QuickBookingController from "./quick_booking_controller"
application.register("quick-booking", QuickBookingController)

import QuickBookingFormController from "./quick_booking_form_controller"
application.register("quick-booking-form", QuickBookingFormController)

import QuizQuestionFormController from "./quiz_question_form_controller"
application.register("quiz-question-form", QuizQuestionFormController)

import RatingController from "./rating_controller"
application.register("rating", RatingController)

import RegistrationController from "./registration_controller"
application.register("registration", RegistrationController)

import ReloadController from "./reload_controller"
application.register("reload", ReloadController)

import ResourceAccessController from "./resource_access_controller"
application.register("resource-access", ResourceAccessController)

import ReviewController from "./review_controller"
application.register("review", ReviewController)

import ReviewFormController from "./review_form_controller"
application.register("review-form", ReviewFormController)

import RichTextMentionsController from "./rich_text_mentions_controller"
application.register("rich-text-mentions", RichTextMentionsController)

import RichTextPreviewController from "./rich_text_preview_controller"
application.register("rich-text-preview", RichTextPreviewController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SectionBuilderController from "./section_builder_controller"
application.register("section-builder", SectionBuilderController)

import ServiceGalleryController from "./service_gallery_controller"
application.register("service-gallery", ServiceGalleryController)

import ServicesController from "./services_controller"
application.register("services", ServicesController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import ShareLinkController from "./share_link_controller"
application.register("share-link", ShareLinkController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SiteCreationFormController from "./site_creation_form_controller"
application.register("site-creation-form", SiteCreationFormController)

import SiteGeneratorController from "./site_generator_controller"
application.register("site-generator", SiteGeneratorController)

import SiteServicesController from "./site_services_controller"
application.register("site-services", SiteServicesController)

import SiteSidebarController from "./site_sidebar_controller"
application.register("site-sidebar", SiteSidebarController)

import SwipeableCardsController from "./swipeable_cards_controller"
application.register("swipeable-cards", SwipeableCardsController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TaskCardController from "./task_card_controller"
application.register("task-card", TaskCardController)

import TeamFilterController from "./team_filter_controller"
application.register("team-filter", TeamFilterController)

import TemplateFilterController from "./template_filter_controller"
application.register("template-filter", TemplateFilterController)

import TemplateFormController from "./template_form_controller"
application.register("template-form", TemplateFormController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import TimeSlotsController from "./time_slots_controller"
application.register("time-slots", TimeSlotsController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import ToggleViewController from "./toggle_view_controller"
application.register("toggle-view", ToggleViewController)

import TurnstileController from "./turnstile_controller"
application.register("turnstile", TurnstileController)

import TvCarouselController from "./tv_carousel_controller"
application.register("tv-carousel", TvCarouselController)

import UserSelectController from "./user_select_controller"
application.register("user-select", UserSelectController)

import TvPromotionFormController from "./tv_promotion_form_controller"
application.register("tv-promotion-form", TvPromotionFormController)

import ArticleEditorController from "./article_editor_controller"
application.register("article-editor", ArticleEditorController)
